module.exports = __webpack_public_path__ + "static/media/B_lavender_cream.e3da81d5.png";